import { TextField } from "@mui/material";
import React from "react";
import { AnalyticsContext } from "../context/analyticsContext";
import { IAppointmentFilter } from "../interface/iAppointmentFilter";

const SearchForNameInput = (): React.JSX.Element => {
  const {
    appointmentFilter,
    setAppointmentFilter,
  }: {
    appointmentFilter: IAppointmentFilter;
    setAppointmentFilter: React.Dispatch<
      React.SetStateAction<IAppointmentFilter>
    >;
  } = React.useContext(AnalyticsContext);

  return (
    <TextField
      label="Name"
      fullWidth
      variant="outlined"
      size="small"
      color="primary"
      onChange={(e) =>
        setAppointmentFilter({
          ...appointmentFilter,
          searchString: (e.target as HTMLInputElement).value,
        })
      }
      value={appointmentFilter.searchString}
    />
  );
};

export default SearchForNameInput;
